<template>
  <div class="another_device_installation">
    <header-component
      :is-soon="false"
      :backRoute="true"
      :progression="false"
      img-left="/trocachip/img/setinha-left-preto.svg"
      img-right="/trocachip/img/access.png"
      class="header-component"
    />
    <div class="another_device_installation-img">
      <img src="@/assets/images/Render-icon.svg" alt="TIM eSIM" />
    </div>
    <div class="another_device_installation_title">
      <span v-html="pageInfo.title"></span>
    </div>
    <div class="installation_instructions">
      <span class="installation_instructions_span">{{ pageInfo.sub_title }}</span>
    </div>
    <section class="device_selection_container">
      <div class="selection_container">
            <div class="selection_input" @click="toggleBrandSelectionOpened">
              <span
                v-html="selectedBrandName()"/>
            </div> 
          </div>
          <div
              class="selection_options_container"
              :class="{ opened_options: brandSelectionOpened }"
            >
              <label
                id="device_mark"
                v-for="(item, index) in brandsList"
                :key="index"
                v-html="item"
                :value="item"
                @click="() => selectBrand(item)"
              />
            </div>
    </section>
    <section class="instructions_list">
      <ul class="instruction_container">
        <li v-for="(step, index) in steps" :key="index" class="instruction_item">
          <div class="instruction_block">
            <div class="instruction_content">
              <img :src="step.image" alt="Step Icon" class="instruction_image" />
              <div class="instruction_text">
                <span class="instruction_main">{{ step.main }}</span>
                <vue-qrcode v-if="step.qrCode" :margin="2" :value="urlEsim" class="qr_code_image" />                               
                <span v-if="step.subtitle" class="instructions_subtitle">{{ step.subtitle }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </section>
    <!--<section class="installation_tutorial_info_card">
      <div class="tutorial_content">
        <div class="text_content" :class="{ 'use-max-width': useMaxWidth }">
          <span v-html="pageInfo.installation_tutorial_title" class="installation_title"></span>
          <span v-html="pageInfo.installation_tutorial_subtitle" class="installation_subtitle"></span>
          <a
            href="#"
            @click.prevent="viewTutorial(pageInfo.installation_tutorial_footer_link)"
            class="tutorial_install_link">
            {{ pageInfo.installation_tutorial_footer_button }}
          </a>
        </div>
        <div class="image_content">
          <img :src="getImageSrc(pageInfo.installation_tutorial_footer_icon)" alt="Info Icon" />
        </div>
      </div>
    </section>-->
     <section class="installation_tutorial_info_card no-background">
      <div class="tutorial_content">
        <div class="text_content" :class="{ 'use-max-width': useMaxWidth }">
          <p v-html="pageInfo.footer_title" id="installation_footer_title" class="installation_title"></p>
          <p v-html="pageInfo.footer_subtitle" class="footer_subtitle"></p>
          <a
            href="#"
            @click.prevent="manualInstallation(pageInfo.footer_link)"
            class="tutorial_install_link" id="installation_footer_button">
            {{ pageInfo.footer_button }}
          </a>
        </div>        
      </div>
      <div class="footer_image">
        <div class="icon_box">
        <img :src="getImageSrc(pageInfo.footer_icon)" alt="" class="footer_icon"/>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import { mapState } from "vuex";
import HeaderComponent from "@/components/HeaderComponent.vue";
import trackEvent from "@/services/trackEvent";
import VueQrcode from "vue-qrcode";

export default {
  name: "AnotherDeviceInstallation",
  components: { HeaderComponent, VueQrcode},
  created() {
    this.sendTracker("passo_a_passo_outro_aparelho", 6, 3);
    this.brandsList = this.pageInfo.steps.map(step => {
      return step.brandName;
    })
    this.steps = this.pageInfo.steps.find(
        (deviceElement) => {
          return deviceElement.brand == this.selectedBrand;
        }
      ).stepList
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      config: (state) => state.config,
      customer: (state) => state.customer,
      pageInfo: (state) => state.config.another_device_installation,
      useMaxWidth: (state) => state.config.another_device_installation.useMaxWidth,
      urlEsim: (state) => state.urlEsim,
      selectedBrand: (state) => state.selectedBrand,
    }),
  },
  data() {
    return {
      brandsList: "",
      steps: [],
      brandSelectionOpened: false
    }
  },
  watch: {
    selectedBrand() {
      this.getStepsByselectedBrand();
    },
  },
  methods: {
    sendTracker(eventLabel, eventCategory = 6, eventAction = 2) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": eventCategory,
        "event-label": eventLabel,
        "event-location": "null",
        "event-value": this.customer.isExOiCustomer ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": eventAction,
      });
    },
    getImageSrc(imageName) {
      return require("@/assets/images/" + imageName);
    },
    viewTutorial(link) {
      this.sendTracker("outro_aparelho_ver_tutorial");
      if (link) {
        this.$router.push({ name: link });
      }
    },
    manualInstallation(link) {
      this.sendTracker("outro_aparelho_instalacao_manual");
      if (link) {
        this.$router.push({ name: link });
      }
    },
    selectedBrandName() {
      const deviceListConfig = this.pageInfo.steps.find(
        (deviceElement) => {
          return deviceElement.brand == this.selectedBrand;
        }
      );
      return deviceListConfig.brandName;
    },
    selectBrand(value) {
      const deviceListConfig = this.pageInfo.steps.find(
        (deviceElement) => {
          return deviceElement.brandName == value;
        })
      console.log("selected Brand: "+value+ " resulting in: "+deviceListConfig.brand);
      this.$store.dispatch("selectedBrand",  deviceListConfig.brand);
      this.brandSelectionOpened = false;
    },
    getStepsByselectedBrand() {
      const deviceListConfig = this.pageInfo.steps.find(
        (deviceElement) => {
          return deviceElement.brand == this.selectedBrand;
        }
      );
      console.log(deviceListConfig)
      if (this.selectedBrand == "Apple") {
        this.$store.dispatch("selectedBrand", "Apple");
      } else if (this.selectedBrand == "Motorola") {
        this.$store.dispatch("selectedBrand", "Motorola");
      } else if (this.selectedBrand == "Samsung") {
        this.$store.dispatch("selectedBrand", "Samsung");
      } else {
        this.$store.dispatch("selectedBrand", "Android");
      }
      if (deviceListConfig !== undefined) {
        this.steps = deviceListConfig.stepList;
      } else {
        this.steps = this.pageInfo.steps.find(
        (deviceElement) => {
          return deviceElement.brand == "Outras marcas";
        })
      }
    },
    toggleBrandSelectionOpened() {
      this.brandSelectionOpened = !this.brandSelectionOpened;
    },
  },
};
</script>

<style lang="scss" scoped>
  .another_device_installation {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  z-index: -1;
  > .page_content {
    margin: 25% 0%;
  }
  .device_selection_container {
      
      margin-top: 2.125rem;
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;
      >.selection_options_container {
          display: none;
        }
        > .selection_options_container.opened_options {
          position: relative;
          display: flex;
          width: 328px;
          max-height: 200px;
          overflow-y: scroll;
          overflow-x: hidden;
          flex-direction: column;
          background: #fff;
          border-radius: 16px;
          box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.15);
          z-index: 10;
          > label {
            width: 100%;
            padding: 24px 0 0 24px;
            font-family: "timsans_regular";
            font-size: 0.875rem;
            color: #9c9c9c;
            line-height: 21px;
            cursor: pointer;
          }
          > label:last-child {
            padding-bottom: 24px;
          }
          > label:hover {
            background-color: #e7e7e7;
          }
        }
      > .selection_container {
        position: relative;
        > .selection_input {
          width: 100%;
          height: 40px;
          padding: 0px 16px;
          border-radius: 24px;
          color: #000000;
          font-family: "timsans_regular";
          font-size: 14px;
          -webkit-appearance: none;
          -moz-appearance: none;
          overflow: auto;
          border: 1px solid #000000;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
        > .selection_input::-ms-expand {
          display: none;
        }
        > .selection_input::after {
          content: "<";
          font: 10px "Consolas", monospace;
          color: #000000;
          -webkit-transform: rotate(180deg) scaleY(1.2);
          -moz-transform: rotate(270deg) scaleY(1.2);
          -ms-transform: rotate(270deg) scaleY(1.2);
          transform: rotate(270deg) scaleY(1.2);
          position: relative;
          pointer-events: none;
          left: 5px;
          width: 10px;
          margin-bottom: 5px;
        }
      }
      > .confirmation_container {
        display: flex;
        flex-direction: row;
        margin: 0px 8px;
        > input {
          width: 52px !important;
          height: 24px !important;
          -webkit-appearance: none;
          border: 1px solid #9c9c9c;
          background: #ffffff;
          color: #ffffff;
          text-align: center;
          border-radius: 8px;
          margin: 0 !important;
          background-position: center;
        }
        > input:checked {
          background-image: url("../../assets/images/on-filled.svg");
          -webkit-appearance: none;
          border-color: transparent;
        }
        > p {
          margin-block: 0 !important;
          margin-left: 0.5rem;
          font-family: "timsans_regular";
          font-size: 0.875rem;
          color: #9c9c9c;
        }
      }
    }
  .another_device_installation-img{
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 85px;
}
  .another_device_installation_title {
    font-weight: 300;
    font-size: 27px;
    line-height: 30px;
    align-items: center;
    display: flex;
    font-family: "timsans_regular";
    width: 280px;
    text-align: center;
    flex-direction: column;
    margin: auto;
    margin-top: 1rem;
  }
  .installation_instructions {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "timsans_regular";
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    margin-top: 1rem;
    color: #696969;
    width: 325px;
    margin: auto;
  }
  .installation_instructions_span {
    margin-top: 1rem;
  }

  .instructions_list {
  padding: 0;
  margin-top: 20px;

    .instruction_container {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;  
      flex-direction: column;

      .instruction_item {
        width: 100%;
        justify-items: center;
        height: auto;
        padding: 40px 0;
        gap: 40px;
        border-bottom: 2px solid #e5e5e5;
        background: #ffffff;

        .instruction_block {
          width: 375px;
          height: auto;
          display: flex;
          align-items: center;
          gap: 24px;

          .instruction_content {
            display: flex;
            align-items: flex-start;
            gap: 24px;
            margin: 0 15px;

            .instruction_image {
              width: 24px;
              height: 24px;
              flex-shrink: 0;
            }

            .instruction_text {
              width: 279px;
              display: flex;
              flex-direction: column;
              gap: 4px;

              .instruction_main {
                font-family: "timsans_bold";
                font-size: 14px;
                font-weight: 500;
                line-height: 21px;
                color: #000000;
              }

              .qr_code_image {
                border-radius: 8px;
                border: 1px solid #e5e5e5;
                display: flex;
                width: 216px;
                height: 216px;
              }

              .instructions_subtitle {
                font-family: "timsans_regular";
                font-size: 14px;
                line-height: 21px;
                font-weight: 400;
                color: #696969;
              }
            }
          }
        }
      }
    }
  }
  

  .installation_tutorial_info_card {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding: 1.5rem;
  background-color: #F0F1F2;
  &.no-background {
    border-top: 4px solid #d9d9d9;
    background-color: transparent; 
  }

  .tutorial_content {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }

  .text_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    width: 255px;
    &.use-max-width {
      max-width: 255px;
    }

    .installation_title {
      font-family: "timsans_regular";
      font-size: 14px;
      line-height: 21px;
      color: #000000;
      margin-bottom: 8px;
      font-weight: bold;
    }

    .installation_subtitle {
      font-family: "timsans_regular";
      font-size: 14px;
      line-height: 21px;
      color: #000000;
      margin-bottom: 16px;
    }

    .QRCode_install_link {
      font-family: "timsans_regular";
      font-size: 16px;
      font-weight: 500;
      color: #0026D9;
      text-decoration: none;
    }
  }

  .image_content {
    flex-shrink: 0;
    margin-left: 24px;

    img {
      width: 24px;
      height: 24px;
    }
  }
}


  

  .footer_subtitle {
    font-family: "timsans_regular";
    font-size: 14px;
    color: #696969;
    line-height: 21px;
  }

  .tutorial_install_link {
    font-family: "timsans_regular";
    font-size: 16px;
    font-weight: bold;
    color: #0026D9;
    text-decoration: none; 
  }

  .footer_image {
    margin-top: 15px;
    margin-left: 24px
  }

  .icon_box {
    width: 48px;
    height: 48px;
    border-radius: 16px;
    border: 1px solid #e5e5e5;
    display: flex;
  }

  .footer_icon {
    margin: auto;
  }
}

</style>